/* eslint-disable global-require */
import React from 'react';
import Loadable from 'react-loadable';

import { useFlashMessagesWithPrefetch } from 'src/client/components/shared/flash-messages/redux/hooks';

import { FlashMessageContainerWrapper } from './Core.styles';

interface Props {
    children: React.ReactNode;
}

const LoadableFlashMessageContainer = Loadable({
    loader: () => import(/* webpackChunkName: "layout" */ './shared/flash-message-container'),
    loading() {
        return <></>;
    },
});

export const CoreAppsLayout = ({ children }: Props) => {
    const messages = useFlashMessagesWithPrefetch();

    return (
        <React.Fragment>
            <FlashMessageContainerWrapper>
                <LoadableFlashMessageContainer messages={messages} />
            </FlashMessageContainerWrapper>
            {children}
        </React.Fragment>
    );
};
